<template lang="pug">
#groupBy-select-container.col-xl-2.col-md-3.col-sm-4.col-xs-10.margin-bottom-sm.selections.groupBy-select-container(
  ref="groupByContainer"
)
  AppSelect(
    v-model="selected"
    :select2-options="select2Options"
    :options="fullOptions"
  )
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReportGroupBy',
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedDefault: {
      type: String,
      default: 'date',
    },
    dispatchKey: {
      type: String,
      default: 'group_by',
    },
    beforeCallback: {
      type: Function,
      default: (_data) => {},
    }
  },
  data() {
    return {
      select2Options: {},
    };
  },
  computed: {
    selected: {
      get() {
        return this.$store.state.report_query[this.dispatchKey] || this.selectedDefault;
      },
      set(selectedValue) {
        const data = {};

        data[this.dispatchKey] = selectedValue;

        this.beforeCallback(data);
        this.$store.dispatch('updateSearch', data);
        this.analyticsTrackReport({
          event: 'Table group by',
          groupProps: true,
          props: { [selectedValue]: true },
        });
      },
    },
    fullOptions() {
      return this.options.map((option) => {
        return { ...option, ...{ resultClass: `is-${option.icon || option.id}` } };
      });
    },
  },
  mounted() {
    this.select2Options.dropdownParent = $(this.$refs.groupByContainer);
    this.$watch('fullOptions', (fullOptions) => {
      if (!fullOptions.find((option) => option.id === this.selected)) {
        this.selected = this.selectedDefault;
      }
    });
  },
  methods: {
    ...mapActions(['analyticsTrackReport']),
    formatOption: function (option, container) {
      const iconClass = option.icon ? option.icon : option.id;

      container.classList.add(`is-${iconClass}`);

      return option.text;
    },
  },
};
</script>
